
import Honkai_Star_Rail_App from "../../assets/imgs/games/Honkai_Star_Rail_App.png";
import Genshin_Impact_App from "../../assets/imgs/games/Genshin_Impact_App.png";
import WuWa from "../../assets/imgs/games/WuWa.png";
import zzzLogo from "../../assets/imgs/games/all/zzz.png";
import honkaiimpact from "../../assets/imgs/games/all/honkaiimpact.png";
import WuWaa from "../../assets/imgs/games/all/WuWaa.png";
import aov from "../../assets/imgs/games/all/ArenaofValor.png";
import mc from "../../assets/imgs/games/all/minecraft.jpg";
import vscode from "../../assets/imgs/games/all/vscode.png";

export const t = {
    gamesTitle: "游戏",
    playedGames: "网页的游戏消息...",
    topGames: "玩得最多",
    allGames: "全部",
    gameEvents: "游戏活动",
    activeCodes: "激活码",
    inactiveCodes: "失效码",
    noActiveCodes: "没有可用的激活码",
    noInactiveCodes: "没有可用的失效码",
    noEvents: "没有可用的事件",
    errorLoading: "❌ 加载数据时出错，请重试",
    copied: "已复制:",
    viewFull: "查看完整事件详情",
    noDescription: "此事件没有详细描述。",
    events: "事件",
    previous: "上一页",
    next: "下一页",
};

export const FALLBACK_IMAGE = "https://via.placeholder.com/520x300?text=无图片";

export const GAME_THEMES = {
    genshin: "from-blue-50 via-cyan-50/30 to-white dark:from-slate-950 dark:via-cyan-950/20 dark:to-slate-900",
    starrail: "from-indigo-50 via-purple-50/30 to-white dark:from-slate-950 dark:via-purple-950/20 dark:to-slate-900",
    zenless: "from-orange-50 via-amber-50/30 to-white dark:from-slate-950 dark:via-orange-950/20 dark:to-slate-900",
    default: "from-slate-50 via-slate-100/30 to-white dark:from-slate-950 dark:via-slate-800/20 dark:to-slate-900"
};

export const ACTIVE_COLORS = {
    genshin: "bg-cyan-600 shadow-cyan-200/50 dark:bg-cyan-500 dark:shadow-cyan-900/50",
    starrail: "bg-indigo-600 shadow-indigo-200/50 dark:bg-indigo-500 dark:shadow-indigo-900/50",
    zenless: "bg-orange-600 shadow-orange-200/50 dark:bg-orange-500 dark:shadow-orange-900/50",
    default: "bg-slate-800 shadow-slate-300/50 dark:bg-slate-600 dark:shadow-slate-900/50"
};

export const TOP_GAMES = [
    { name: "Genshin Impact", time: 1324, img: Genshin_Impact_App, url: "https://genshin.hoyoverse.com/" },
    { name: "Honkai Star Rail", time: 17531.64, img: Honkai_Star_Rail_App, url: "https://hsr.hoyoverse.com/" },
    { name: "Wuthering Waves", time: 54, img: WuWa, url: "https://wutheringwaves.kurogames.com/" },
    { name: "VSCode", time: 3000, img: vscode, url: "https://code.visualstudio.com/" },
];

export const ALL_GAMES = [
    { name: "Zenless Zone Zero", time: 320, img: zzzLogo, url: "https://zenless.hoyoverse.com/" },
    { name: "Honkai Impact 3rd", time: 56, img: honkaiimpact, url: "https://honkaiimpact3.hoyoverse.com/" },
    { name: "Wuthering Waves", time: 54, img: WuWaa, url: "https://wutheringwaves.kurogames.com/" },
    { name: "Arena of Valor", time: 240, img: aov, url: "https://www.arenaofvalor.com/" },
    { name: "Minecraft", time: 1500, img: mc, url: "https://www.minecraft.net/" },
    { name: "VSCode", time: 3000, img: vscode, url: "https://code.visualstudio.com/" },
];

export const GAME_SELECTOR_ITEMS = [
    { id: 'genshin', icon: Genshin_Impact_App, name: '原神' },
    { id: 'starrail', icon: Honkai_Star_Rail_App, name: '星铁' },
    { id: 'zenless', icon: zzzLogo, name: '绝区零' }
];

export const TABS = [
    { id: 'news', name: '活动资讯' },
    { id: 'codes', name: '兑换码' }
];
